class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      cartDrawer: ".cart-drawer",
      overlay: ".cart-drawer__overlay",
      close: ".cart-drawer-close",
    };

  }

  connectedCallback() {
    this.setupListeners();
  }

  disconnectedCallback() {
    this.removeListeners();
  }

  setupListeners() {

    // close drawer when pressing escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.toggle("close");
      }
    });
  }

  removeListeners() {
    this.querySelector(this.selectors.overlay).removeEventListener(
      "click",
      this.toggle.bind(this)
    );
    this.querySelector(this.selectors.close).removeEventListener(
      "click",
      this.toggle.bind(this)
    );
  }

  renderContents(parsedState) {

    this.classList.remove('is-empty');
    this.querySelector('.cart-drawer__inner').classList.contains('is-empty') && this.querySelector('.cart-drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getCartDrawerSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    this.toggle("open");
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".js-contents",
        childSectionSelectors: ['.cart-drawer__heading', '.cart-drawer__free-delivery', '.cart-drawer__items', '.cart-drawer__footer']
      },
      {
        id: 'cart-bubble-count',
        section: 'cart-bubble-count',
        selector: '.shopify-section'
      }
    ];
  }

  getCartDrawerSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#cart-drawer--container',
        childSectionSelectors: [
          '.drawer__heading',
          '.cart__free-shipping',
          '.drawer__contents',
          '.cart-drawer__footer-info'
        ]
      },
      {
        id: 'cart-bubble-count',
      }
    ];
  }

  toggle(state) {
    if (state === "close") {
      this.classList.remove("active");
      document.querySelector("html").classList.remove("cart-drawer-open");
      return;
    } else if (state === "open") {
      setTimeout(() => {this.classList.add('active')}, 50);
      document.querySelector("html").classList.add("cart-drawer-open");
      return;
    }
    this.classList.toggle("active");
    document.querySelector("html").classList.toggle("cart-drawer-open");
}

fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

}

customElements.define("cart-drawer", CartDrawer);

class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartDrawer = this.closest('cart-drawer');
        const cartItems = this.closest('cart-items');
        // if (cartItems.cartDrawerUpsells) cartItems.cartDrawerUpsells.classList.add('cart-drawer-recommendations--loading');
          cartItems.updateQuantity(this.dataset.line, 0);
      });
    }
  }

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
      super();

      this.cartDrawerUpsells = this.querySelector('.cart-drawer-recommendations');
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
  
      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.line, event.target.value, document.activeElement.getAttribute('name'));
      }

    updateQuantity(line, quantity, name) {
        let cartUrl = window.routes.cartChangeUrl;
        let cartDrawer = this.closest('cart-drawer');
        let body = JSON.stringify({
          line,
          quantity,
          sections: cartDrawer.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
    
        fetch(`${cartUrl}`, {...cartDrawer.fetchConfig(), ...{ body }})
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            console.log('parsedState', parsedState);
            
            const quantityElement = this.querySelector(`.quantity-selector__value[data-line="${line}"]`);
            const cartDrawerInner = this.closest('.cart-drawer__inner');
    
            if (parsedState.errors) {
              return;
            }
    
            this.classList.toggle('is-empty', parsedState.item_count === 0);
    
            if (parsedState.item_count === 0 && this.cartDrawerUpsells) {
                this.closeUpsells();
            }
    
            cartDrawer.getSectionsToRender().forEach((section => {
              if (section.childSectionSelectors) {
                section.childSectionSelectors.forEach((elem) => {
    
                  if (parsedState.item_count > 0 && quantity === 0 && elem == '.cart-drawer__items') {
                    console.log('cartRecommendationsHtml passed');
                    
                    const cartRecommendationsHtml = cartDrawer.getSectionInnerHTML(parsedState.sections[section.section], `${elem} .cart-drawer-recommendations`);
                    if (this.cartDrawerUpsells) {
                      this.updateUpsells(cartRecommendationsHtml, cartDrawerInner);
                    }
                  }
                  const elementToReplace = document.getElementById(section.id).querySelector(elem).querySelector(section.selector) || document.getElementById(section.id);
                  const mainCartInnerHtml = cartDrawer.getSectionInnerHTML(parsedState.sections[section.section], `${elem} ${section.selector}`);
                  elementToReplace.innerHTML = mainCartInnerHtml;
                });
              } else {
                const sectionElement = document.getElementById(section.id);
                if (sectionElement) {
                  const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
                  elementToReplace.innerHTML = cartDrawer.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }
              }
            }));

          }).catch((error) => {
            alert('error', error);
          });
      }


  closeUpsells(cartDrawerInner) {
    console.log('closeUpsells, ', this.cartDrawerUpsells);
    
    this.cartDrawerUpsells.style.transform = 'translate(100%)';
    this.cartDrawerUpsells.addEventListener('transitionend', () => {
      if (cartDrawerInner) cartDrawerInner.classList.remove('drawer__inner--no-border');
      this.cartDrawerUpsells.classList.add('close');
    }, { once: true });
  }

  updateUpsells(cartRecommendationsHtml, cartDrawerInner) {
    if (cartRecommendationsHtml === "") {
      this.cartDrawerUpsells.classList.remove('cart-drawer-recommendations--loading');
      this.closeUpsells(cartDrawerInner);
    } else {
      const cartDrawerRecommendationsList = this.cartDrawerUpsells.querySelector('.cart-drawer-recommendations__list');
      if (cartDrawerRecommendationsList) {
        cartDrawerRecommendationsList.classList.add('disable-list');
        if (cartDrawerInner) cartDrawerInner.classList.add('drawer__inner--no-border');
        this.cartDrawerUpsells.classList.remove('close');
      }

      setTimeout(() => {
        this.cartDrawerUpsells.innerHTML = cartRecommendationsHtml;
      }, 200);
    }
  }

  }

customElements.define('cart-items', CartItems);

class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.errorEvent = new Event('error', { bubbles: true });

      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    connectedCallback() {
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      const maxNumberValue = parseInt(this.input.getAttribute('max')) || null;
      const parentElem = event.target.parentElement;
      const plusButton = parentElem.querySelector('.quantity-selector__button--increase');
      const minusButton = parentElem.querySelector('.quantity-selector__button--decrease');
      const inputNumberValue = parseInt(this.input.value);
  
      if (!maxNumberValue || inputNumberValue < maxNumberValue) {
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      } else if (inputNumberValue === maxNumberValue && event.target.name === 'minus') {
        this.input.stepDown();
      }
  
      if (maxNumberValue && event.target.name === 'plus') {
        const newValue = parseInt(this.input.value);
        if (inputNumberValue >= maxNumberValue) {
          this.input.dispatchEvent(this.errorEvent);
          plusButton.setAttribute('disabled', true);
        }
      } else {
        plusButton.removeAttribute('disabled');
      }
  
      if (this.input.value === '1') {
        minusButton.setAttribute('disabled', true);
      } else {
        minusButton.removeAttribute('disabled');
      }
  
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

  }
  
  customElements.define('quantity-input', QuantityInput);


  class ProductItem extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('form');
      if (this.productForm) {
        this.summitButton = this.productForm.querySelector('[type="submit"]');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.productForm.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
  
      this.summitButton.disabled = true;
      this.summitButton.setAttribute('aria-disabled', true);
      this.summitButton.classList.add('btn--loading');
  
      const config = this.cartDrawer.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.productForm);
  
      if (this.cartDrawer) {
        formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;
  
      fetch(`${window.routes.cartAddUrl}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.cartDrawer.renderContents(response);
        })
        .finally(() => {
          this.summitButton.disabled = false;
          this.summitButton.removeAttribute('aria-disabled');
          this.summitButton.classList.remove('btn--loading');
        });
    }
  }
  
  customElements.define('product-item', ProductItem);

class CartRecommendations extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          if (this.classList.contains('product-recommendations--loaded')) {
            return;
          }
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('cart-recommendations');
          const cartDrawerUpsells = this.closest('.cart-drawer-recommendations');
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            cartDrawerUpsells.classList.remove('cart-drawer-recommendations--loading');
            this.innerHTML = recommendations.innerHTML;
            const cartDrawerRecommendationsList = this.querySelector('.cart-drawer-recommendations__list');
  
            if (cartDrawerRecommendationsList) {
              setTimeout(() => {
                this.querySelector('.cart-drawer-recommendations__list').classList.remove('disable-list');
              });
            }
          }
  
          const cartDrawerInner = cartDrawerUpsells.closest('.drawer__inner');
          if (!this.querySelector('.cart-drawer-recommendations__list')) {
            cartDrawerUpsells.classList.add('close');
            setTimeout(() => {
              if (cartDrawerInner) cartDrawerInner.classList.remove('drawer__inner--no-border');
            }, 200);
          } else {
            if (cartDrawerInner) cartDrawerInner.classList.add('drawer__inner--no-border');
            cartDrawerUpsells.classList.remove('close');
          }
  
          this.classList.add('product-recommendations--loaded');
  
          if (this.classList.contains('complementary-products') ) {
            this.querySelectorAll('script').forEach(oldScriptTag => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach(attribute => {
                newScriptTag.setAttribute(attribute.name, attribute.value)
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
  
  customElements.define('cart-recommendations', CartRecommendations);

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  